//------------------------------
// get auto adjustment payloads
//------------------------------
export default function getAutoAdjPayloads(adjs) {
  console.log('-------------------------------------')
  console.log('IN getAutoAdjPayloads adjs = ', adjs)
  let payloads = []
  //-----------------------------------------------
  // group adjs by source and name e.g. ability/cr
  //-----------------------------------------------
  const groupedAdjs = adjs.reduce((groups, a) => {
    const key = `${a.source}:${a.name}`
    if (!groups[key]) {
      groups[key] = []
    }
    groups[key].push(a)
    return groups
  }, {})
  console.log('GROUPED ADJS = ', groupedAdjs)
  //-----------------
  // loop each group
  //-----------------
  Object.entries(groupedAdjs).forEach(([key, adjsInGroup]) => {
    const [source, name] = key.split(':')
    // console.log(`Processing ${source}:${name} with ${adjsInGroup.length} adjs`)
    //----------------------------------------------
    // set payload for this source+name combination
    //----------------------------------------------
    const payload = {
      category: source,
      type: name,
      data: adjsInGroup,
    }
    payloads.push(payload)
  })
  return payloads
}
